import YFormUploader from './Uploader';

export { YFormUploader };
export default YFormUploader;
